import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, EventEmitter, OnDestroy } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TransportationType } from '@signal/asp-data-commons';
import { Subscription } from 'rxjs';
import { ShopMaxPerDay } from 'src/app/modules/shared/models/slot-management.model';
import { SalesAvailabilityState } from 'src/app/modules/store/sales-availability/sales-availability.reducer';
import { TranslateService } from '@ngx-translate/core';
import { SlotState } from 'src/app/modules/store/slot/slot.reducer';
import { titleCase, unsubscribeSubscriptions } from '../../services/util.service';
import _ from 'lodash'
import { SubscriptionList } from '../../models/asp.types';

@Component({
  selector: 'app-transport-max',
  templateUrl: './transport-max.component.html',
  styleUrls: ['./transport-max.component.scss']
})
export class TransportMaxComponent implements OnInit, OnChanges, OnDestroy {

  @Input() viewMode: string = 'Rental';
  @Input() transportMaxTotal$: ShopMaxPerDay[];
  @Input() switchInput:boolean;
  @Output() saveChanges: EventEmitter<any> = new EventEmitter();
  @Input() saveClicked:boolean
  @Input() cancleClicked:boolean
  @Output() formEdited:EventEmitter<boolean> = new EventEmitter();
  @Output() cancleClick:EventEmitter<boolean> = new EventEmitter();
  @Output() saveClick:EventEmitter<boolean>=new EventEmitter();
  isFormEdited:boolean=false;
  lastValue:any

  totalCapacity: number = 0;
  subscriptions: SubscriptionList = {};
  transportMaxForm: UntypedFormGroup;

  constructor(private readonly formBuilder: UntypedFormBuilder,
    private translate: TranslateService) {
    this.transportMaxForm = this.formBuilder.group({
      transportMaxDetails: this.formBuilder.array([])
    });
  }

  ngOnInit() {
    this.subscriptions.form = this.transportMaxForm.valueChanges.subscribe(value => {
         this.calculateTotals();
         this.formEdited.emit(this.transportMaxForm.dirty)
       })
   }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.hasOwnProperty("transportMaxTotal$")){
      this.setTransportMaxDetails(this.transportMaxDetails, this.transportMaxTotal$);
      this.calculateTotals();
    }
    if(this.saveClicked && this.transportMaxForm.dirty)
    {
      this.onSave();
    }
    if(this.cancleClicked && this.transportMaxForm.dirty)
    {
      this.onCancel();
    }
  }
viewModeText(viewMode){

   if(viewMode.toUpperCase() === 'RENTAL')
     {
       return this.translate.instant('transportCapacity.rentalMaxSlotsPerDay');
     }
     else if(viewMode.toUpperCase() === 'SHUTTLE')
     {
       return this.translate.instant('transportCapacity.shuttleMaxSlotsPerDay');
     }
     else if(viewMode.toUpperCase() === 'REMOTE')
     {
       return this.translate.instant('transportCapacity.remoteMaxSlotsPerDay');
     }
     else if(viewMode?.toUpperCase() === 'TXM')
     {
       return this.translate.instant('departmentCapacity.txmTeamMaxSlotsPerDay');
     }
     else{
       return `${viewMode} Max Slots Per Day`
     }
}
   get transport(){
    return TransportationType;
  }

   calculateTotals(){
    this.totalCapacity = 0;
    this.transportMaxDetails.value.forEach(a => this.totalCapacity += a.slotCapacity);
   }

  get transportMaxDetails() {
    return this.transportMaxForm.controls.transportMaxDetails as UntypedFormArray;
  }

  setTransportMaxDetails(formArray: UntypedFormArray, data: ShopMaxPerDay[]) {
    if (data && data.length) {
      formArray.clear();
      data.forEach((total: ShopMaxPerDay) => {
        formArray.push(new UntypedFormGroup({
          dayOfWeek: new UntypedFormControl(total.dayOfWeek),
          hoursOfOperation: new UntypedFormControl(total.hoursOfOperation),
          slotCapacity: new UntypedFormControl(total.slotCapacity),
        }));
      });
    }
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subscriptions);
  }

  onSave(){
    this.saveChanges.emit(this.transportMaxDetails.value);
    this.saveClick.emit(false)
    this.formEdited.emit(false)
    this.transportMaxForm.markAsPristine()
  }

  getWeekDays(day)
  {
    return this.translate.instant(`common.${titleCase(day)}`)
  }

  onCancel(){
      this.setTransportMaxDetails(this.transportMaxDetails, this.transportMaxTotal$);
      this.cancleClick.emit(false)
  }

}
